<template>
  <div class="clearfloat all">
    <article class="success">
      <h3 class="caption">申请退货</h3>
      <section class="contents">
        <p class="dark-grey">售后申请提交成功</p>
        <p class="grey">售后专员可能与您电话沟通,请保持手机畅通</p>
        <router-link tag="button" class="back" to="/personCenter/afterSales">返 回</router-link>
      </section>
      <section class="tips">
        <p>温馨提示:</p>
        <p>*商品寄回地址将在审核通过后以短信形式告知，或在申请记录中查询。</p>
        <p>*提交服务单后，售后专员可能与您电话沟通，请保持手机畅通。</p>
        <p>*售后处理成功后退款金额将原路返回到您的支付账户中。</p>
      </section>
    </article>
  </div>
</template>
<script>
export default {
  name: 'submit-success',
  components: {}
}
</script>
<style lang="scss" scoped>
.all {
  overflow: hidden;
}
.success {
  width: 1085px;
  .caption {
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    margin-bottom: 15px;
  }
  .contents {
    height: 420px;
    background: #fff url('../../assets/images/after/submitsuccess.png') no-repeat center 99px;
    background-size: 72px;
    overflow: hidden;
    position: relative;
    text-align: center;
    .dark-grey {
      margin: 191px 0px 10px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    .grey {
      font-size: 16px;
      color: #666666;
      line-height: 22px;
      margin-bottom: 49px;
    }
    button.back {
      width: 133px;
      height: 40px;
      background: #000000;
      border: 0;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      -moz-transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      -o-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      cursor: pointer;
      outline: none;
      color: #ffffff;
      font-size: 18px;
    }
  }
  .tips {
    margin: 30px 0px 0;
    height: 109px;
    padding: 15px 0 0 40px;
    background: rgba(247, 165, 0, 0.1) url('../../assets/images/after/tips.png') no-repeat 16px 15px;
    background-size: 16px;
    border: 1px solid rgba(247, 165, 0, 0.35);
    text-align: left;
    // font-size: $fontsize-medium;
    p {
      margin-bottom: 6px;
    }
  }
}
.clearfloat::after {
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}
</style>
